import TYPES from './types';
import { get, put, post, deleteRequest } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import { updateTableRow, resetTableRowUpdate } from 'store/tables/lists/actions';

export const getUsers = params => dispatch => {
  dispatch({ type: TYPES.GET_PERSONS.START, payload: { params } });

  return get('/orca-users', params)
    .then(response => {
      dispatch({ type: TYPES.GET_PERSONS.SUCCESS, payload: response.data });
    })
    .catch(error => dispatch({ type: TYPES.GET_PERSONS.ERROR, payload: error }));
};

export const getUser = params => dispatch => {
  dispatch({ type: TYPES.GET_PERSON.START, payload: { params } });

  return get(`/orca-users/${params.id}`)
    .then(response => {
      dispatch({ type: TYPES.GET_PERSON.SUCCESS, payload: response.data });

      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.GET_PERSON.ERROR, payload: error }));
};

export const updateUser = params => dispatch => {
  const { id, table, ...rest } = params;
  dispatch({ type: TYPES.UPDATE_PERSON.START, payload: { params } });
  dispatch(updateTableRow({ data: params, table }));

  return put(`/orca-users/${id}`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.UPDATE_PERSON.SUCCESS, payload: response.data });
      dispatch(updateTableRow({ data: response.data, table }));
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));

      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.UPDATE_PERSON.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};

export const createUser = params => dispatch => {
  dispatch({ type: TYPES.CREATE_PERSON.START, payload: { params } });

  return post('/orca-users', params)
    .then(response => {
      dispatch({ type: TYPES.CREATE_PERSON.SUCCESS, payload: response.data });

      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.CREATE_PERSON.ERROR, payload: error });
      return error;
    });
};

export const archiveUser = params => dispatch => {
  dispatch({ type: TYPES.ARCHIVE_PERSON.START, payload: { params } });

  return deleteRequest(`/orca-users/${params.id}`)
    .then(response => {
      dispatch({ type: TYPES.ARCHIVE_PERSON.SUCCESS, payload: response.data });

      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.ARCHIVE_PERSON.ERROR, payload: error }));
};
